import React from 'react';
import { t } from './translations';

/**
 * Price row rendered inside the info column under the feature cards on the
 * new-model print template (Autodis OMODA/JAECOO). Divider on top — no
 * background, чтобы интегрироваться с остальной info-col.
 *
 * @param {object} props
 * @param {number|null|undefined} props.price — regular price.
 * @param {number|null|undefined} [props.promoPrice] — promo price; rendered
 *   below the regular when present and different.
 * @param {(price: number|null|undefined) => string} props.formatPrice
 * @param {'fr'|'en'|'de'|'lu'} [props.language='fr']
 */
const NewModelPriceTag = ({ price, promoPrice, formatPrice, language = 'fr' }) => {
  const showPromo = promoPrice && promoPrice !== price;
  return (
    <div className="print-template__price-bottom">
      <span className="print-template__price-fullwidth-label">{t('fromPrice', language)}</span>
      <span className="print-template__price-fullwidth-amount">{formatPrice(price)}</span>
      {showPromo && (
        <span className="print-template__price-fullwidth-promo">
          {formatPrice(promoPrice)} {t('promoDeducted', language)}
        </span>
      )}
    </div>
  );
};

export default NewModelPriceTag;
